// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__pAxGF","spin":"Spinner_spin__baH8M"};